(() => {
  if (window.__cardColorSwatchesLoaded) return;
  window.__cardColorSwatchesLoaded = true;

  const findPrimaryImg = (wrapper) => {
    const media = wrapper.querySelector('.card__media .media');
    if (!media) return null;
    return media.querySelector('img');
  };

  const findSecondaryImg = (wrapper) => {
    const media = wrapper.querySelector('.card__media .media');
    if (!media) return null;
    const imgs = media.querySelectorAll('img');
    return imgs[1] || null;
  };

  // Snapshot the original primary src/srcset/alt the first time we touch the card
  // so hover-preview can revert to it on mouseleave.
  const snapshot = (wrapper) => {
    if (wrapper.dataset.ccsSnapshotted) return;
    const primary = findPrimaryImg(wrapper);
    if (primary) {
      wrapper.dataset.ccsOrigSrc = primary.src;
      wrapper.dataset.ccsOrigSrcset = primary.srcset || '';
      wrapper.dataset.ccsOrigAlt = primary.alt || '';
    }
    wrapper.dataset.ccsSnapshotted = '1';
  };

  const applyImage = (wrapper, src, srcset, alt) => {
    const primary = findPrimaryImg(wrapper);
    if (!primary || !src) return;
    primary.src = src;
    primary.srcset = srcset || '';
    if (alt) primary.alt = alt;
    // Hide secondary hover image so it doesn't reveal the original product on mouseover
    const secondary = findSecondaryImg(wrapper);
    if (secondary) secondary.style.display = 'none';
  };

  const restoreToActive = (wrapper) => {
    const list = wrapper.querySelector('.card-color-swatches');
    if (!list) return;
    const active = list.querySelector('.card-color-swatches__swatch.is-active');
    if (active) {
      applyImage(wrapper, active.dataset.cardImage, active.dataset.cardImageSrcset, active.dataset.cardImageAlt || '');
    } else {
      // No active swatch found — revert to original snapshot
      applyImage(wrapper, wrapper.dataset.ccsOrigSrc, wrapper.dataset.ccsOrigSrcset, wrapper.dataset.ccsOrigAlt || '');
    }
  };

  // Hover/focus preview — use pointerenter/leave so it works for mouse + pen
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType === 'touch') return;
    const swatch = e.target.closest('.card-color-swatches__swatch');
    if (!swatch) return;
    const wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    snapshot(wrapper);
    swatch.classList.add('is-hover');
    if (!swatch.classList.contains('is-active')) {
      applyImage(wrapper, swatch.dataset.cardImage, swatch.dataset.cardImageSrcset, swatch.dataset.cardImageAlt || '');
    }
  });

  document.addEventListener('pointerout', (e) => {
    if (e.pointerType === 'touch') return;
    const swatch = e.target.closest('.card-color-swatches__swatch');
    if (!swatch) return;
    swatch.classList.remove('is-hover');
    const wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    if (!swatch.classList.contains('is-active')) {
      restoreToActive(wrapper);
    }
  });

  // Focus + blur (keyboard navigation)
  document.addEventListener('focusin', (e) => {
    const swatch = e.target.closest('.card-color-swatches__swatch');
    if (!swatch) return;
    const wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    snapshot(wrapper);
    if (!swatch.classList.contains('is-active')) {
      applyImage(wrapper, swatch.dataset.cardImage, swatch.dataset.cardImageSrcset, swatch.dataset.cardImageAlt || '');
    }
  });
  document.addEventListener('focusout', (e) => {
    const swatch = e.target.closest('.card-color-swatches__swatch');
    if (!swatch) return;
    const wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    if (!swatch.classList.contains('is-active')) {
      restoreToActive(wrapper);
    }
  });

  // Click commits the choice — image stays swapped + anchors rewritten
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.card-color-swatches__swatch');
    if (!swatch) return;
    e.preventDefault();
    if (swatch.classList.contains('is-active')) return;

    const wrapper = swatch.closest('.card-wrapper');
    if (!wrapper) return;
    snapshot(wrapper);

    applyImage(wrapper, swatch.dataset.cardImage, swatch.dataset.cardImageSrcset, swatch.dataset.cardImageAlt || '');

    const newUrl = swatch.dataset.cardProductUrl;
    if (newUrl) {
      // Rewrite every <a> inside the card to the new product, but skip the swatch list
      wrapper.querySelectorAll('a[href]').forEach((a) => {
        if (a.closest('.card-color-swatches')) return;
        a.setAttribute('href', newUrl);
      });
      // Update quick-add data-product-url so the modal fetches the right product
      wrapper.querySelectorAll('[data-product-url]').forEach((b) => {
        b.setAttribute('data-product-url', newUrl);
      });
    }

    // Update active state
    const list = swatch.closest('.card-color-swatches');
    if (list) {
      list.querySelectorAll('.card-color-swatches__swatch').forEach((s) => s.classList.remove('is-active'));
    }
    swatch.classList.add('is-active');
  });
})();
